import { Done } from "@mui/icons-material";
import { MenuItem, Typography } from "@mui/material";
import { useTranslation } from "react-i18next"

type InnerMenuItemType = {
    languageText: string;
    languageValue: string;
    onClick: () => void;
}

export const InnerMenuItem: React.FC<InnerMenuItemType> = ({
    languageText,
    languageValue,
    onClick
}) => { 

    const { i18n } = useTranslation();

    return (
        <MenuItem
            onClick={() => {i18n.changeLanguage(languageValue); onClick()}}
            sx={{
                color: "#595959",
                borderBottom: "1px solid #0000001A",
                display: "flex",
                justifyContent: "space-between",
                ':hover': {
                backgroundColor: "#E9EFF4",
                color: "#22638D"
                }
            }}
            >
            <Typography>
                {languageText}
            </Typography>
            { i18n.language == languageValue && (
                <Done color='info' />
            ) }
        </MenuItem>
    )
}